<template>
    <section class="container">
        <div class="row">
            <div class="col-md-3 col-12">
                <div>
                    <div class="kt-portlet kt-portlet--solid-seconday">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title"><i class="fa fa-info-circle"></i> Datos generales</h3>
                            </div>
                        </div>
                        <button class="btn btn-primary d-block d-sm-none" type="button" @click="visible = !visible">
                            Detalles
                        </button>
                        <div class="kt-portlet__body sin-p">
                            <div  class="kt-widget1 animated fadeIn" :class="!visible ? 'd-none d-sm-block' : ''">
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Marca</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt7}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Modelo</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt6}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Cliente</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt4}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item" v-if="paso1.datos.dt8">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Aseguradora</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt8}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Observación</h3>
                                        <span class="kt-widget1__desc">{{paso1.datos.dt3}}</span>
                                    </div>
                                </div>
                                <div class="kt-widget1__item">
                                    <div class="kt-widget1__info">
                                        <h3 class="kt-widget1__title">Dirección</h3>
                                        <span class="kt-widget1__desc">{{paso1.agencia.empresa}} {{paso1.agencia.nombre}} {{paso1.agencia.detalles}} </span>
                                    </div>
                                </div>
                                <template v-for="item in paso1.datos.elements" >
                                    <div class="kt-widget1__item"  v-if="serializarTitulo(item.dt1)" :key="item.hsh1">
                                        <div class="kt-widget1__info" >
                                            <h3 class="kt-widget1__title">{{serializarTitulo(item.dt1)}}</h3>
                                            <span class="kt-widget1__desc">{{formatoFecha(item)}}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-9 col-12">
                <div class="row">
                    <div class="col-md-4 col-12">
                        <div class="alert alert-outline-primary fade show p-2" role="alert" v-if="dtoActual.dt1 || dtoActual.dt2">
                            <div class="alert-icon"><i class="la la-info-circle"></i></div>
                            <div class="alert-text"><b>{{dtoActual.dt2}}</b></div>
                        </div>
                    </div>
                    <div class="col-md-4 col-12">
                        <div class="alert alert-outline-primary fade show p-2" role="alert">
                            <div class="alert-icon"><i class="la la-barcode"></i></div>
                            <div class="alert-text"><b>#{{paso1.datos.dt1}}</b></div>
                        </div>
                    </div>
                    <div class="col-md-4 col-12">
                        <div class="alert alert-outline-primary fade show p-2" role="alert">
                            <div class="alert-text">
                                Avance
                                <div class="progress">
                                    <div class="progress-bar progress-bar-striped progress-bar-animated " role="progressbar" :aria-valuenow="calculoPor(paso1.datos.elements)" aria-valuemin="0" aria-valuemax="100" :style="'width:'+calculoPor(paso1.datos.elements)+'%'">
                                        {{calculoPor(paso1.datos.elements)}}%
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="">
                    <carusel :lista="paso1.datos.elements2" v-model="dtoActual"></carusel>
                </div>
            </div>
        </div>
        <div class="row p-3 d-flex justify-content-between">
            <button type="button" class="btn btn-lg btn-secondary btn-font-sm" v-on:click="atras"><i class="flaticon2-back"></i> Regresar</button>
        </div>
    </section>
</template>
<script>
    import carusel from "../componentes/carusel";
    import constantes from "../constantes";
    export default {
        name: "paso-2",
        data:()=>({
            formulario:{
                mapaeleige: null,
            },
            currentId:null,
            ventana:null,
            imagenes:[],
            dtoActual:{
                dt2:null,
                dt1:null,
            },
            visible:false,
        }),
        components:{
            carusel
        },
        computed:{
            paso1:function(){
                return this.$store.getters.getPasos[1];
            },
            fotos:function(){
                let vector=[];
                this.$store.getters.getPasos[1].datos.elements2.map(item=>{
                    vector.push({src:process.env.VUE_APP_URL_API+item.dt4,id:item.hsh1,thumbnail:process.env.VUE_APP_URL_API+item.dt4})
                });
                return vector;
            }
        },
        methods:{
            mini:(texto)=>constantes.funciones.minusculas(texto),
            serializarTitulo:function(texto){
                let alternativo = this.mini(texto);
                switch (texto) {
                    case 'RECEPCION':
                        alternativo="Fecha recepción";
                        break;
                    case 'OFRECE' :
                        alternativo="Fecha estimada de entrega";
                        break;
                    case 'AUTORIZACION ASEGURADORA' :
                        alternativo="Fecha de autorización de Aseguradora";
                        break;
                    case 'INSPECCION ASEGURADORA' :
                        alternativo=null;//Fecha de inspección de Aseguradora
                        break;
                    default:
                        alternativo=null;
                        break;
                }
                return alternativo;
            },
            formatoFecha:function(fecha){
                return fecha ? this.$moment(fecha.ddt1, "YYYY-MM-DDTHH:mm:ss").format("ddd DD MMM YYYY") : null;
            },
            siguiente:function(){
                this.$store.commit('setActual', 3);
                this.$router.push({ name: 'p3' });
            },
            atras:function(){
                this.$store.commit('setActual', 1);
                this.$router.push({ name: 'p1' });
            },
            calculoPor:function(fechas){
                let inicio  = fechas.find(o => o.dt1 === 'RECEPCION');
                let fin     = fechas.find(o => o.dt1 === 'OFRECE');
                if(inicio && fin){
                    const a   =   this.$moment().add(-1,"day");
                    const i   =   this.$moment(inicio.ddt1, "YYYY-MM-DDTHH:mm:ss");
                    const f   =   this.$moment(fin.ddt1, "YYYY-MM-DDTHH:mm:ss");
                    const max =   f.diff(i, 'minutes');
                    const ac  =   f.diff(a, 'minutes')>0 ? f.diff(a, 'minutes') : max;
                    return ((ac*100)/max).toFixed(0);
                }else{
                    return 0;
                }
            }
        },
        created() {
            this.$store.commit('setActual', 2);
        }
    }
</script>
<style scoped>
    .btn-elevate{
        display:block;
    }
    .sin-p{
        padding: 0px !important;
    }
    @media (min-width: 768px) {
        .collapsed  {
            display: block;
            height: auto !important;
            visibility: visible;
        }
    }
</style>
